/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AdminContingentCreditsRequestDto } from '../model/adminContingentCreditsRequestDto';
import { AdminContingentDto } from '../model/adminContingentDto';
import { AdminContingentLimitsRequestDto } from '../model/adminContingentLimitsRequestDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AdminContingentManagementService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Credits gutschreiben
     * target&#x3D;CREDITS (Default) wirkt bis zum naechsten Abozyklus, target&#x3D;ADD_ON verfaellt nicht und ueberlebt eine Kuendigung
     * @param scope 
     * @param ownerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addCredits(scope: string, ownerId: number, body?: AdminContingentCreditsRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AdminContingentDto>;
    public addCredits(scope: string, ownerId: number, body?: AdminContingentCreditsRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminContingentDto>>;
    public addCredits(scope: string, ownerId: number, body?: AdminContingentCreditsRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminContingentDto>>;
    public addCredits(scope: string, ownerId: number, body?: AdminContingentCreditsRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scope === null || scope === undefined) {
            throw new Error('Required parameter scope was null or undefined when calling addCredits.');
        }

        if (ownerId === null || ownerId === undefined) {
            throw new Error('Required parameter ownerId was null or undefined when calling addCredits.');
        }


        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminContingentDto>('post',`${this.basePath}/admin/contingents/${encodeURIComponent(String(scope))}/${encodeURIComponent(String(ownerId))}/credits`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Kontingent abrufen
     * Grenzen, Credits, Abozyklus und verbleibende Laeufe je Modul
     * @param scope users oder organisations
     * @param ownerId ID des Mandanten
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContingent1(scope: string, ownerId: number, observe?: 'body', reportProgress?: boolean): Observable<AdminContingentDto>;
    public getContingent1(scope: string, ownerId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminContingentDto>>;
    public getContingent1(scope: string, ownerId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminContingentDto>>;
    public getContingent1(scope: string, ownerId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scope === null || scope === undefined) {
            throw new Error('Required parameter scope was null or undefined when calling getContingent1.');
        }

        if (ownerId === null || ownerId === undefined) {
            throw new Error('Required parameter ownerId was null or undefined when calling getContingent1.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminContingentDto>('get',`${this.basePath}/admin/contingents/${encodeURIComponent(String(scope))}/${encodeURIComponent(String(ownerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * chatBIC-Verbrauch zuruecksetzen
     * Setzt contingent.chat_tokens_used auf 0; die Historie in token_usage bleibt erhalten
     * @param scope 
     * @param ownerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetChatUsage(scope: string, ownerId: number, observe?: 'body', reportProgress?: boolean): Observable<AdminContingentDto>;
    public resetChatUsage(scope: string, ownerId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminContingentDto>>;
    public resetChatUsage(scope: string, ownerId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminContingentDto>>;
    public resetChatUsage(scope: string, ownerId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scope === null || scope === undefined) {
            throw new Error('Required parameter scope was null or undefined when calling resetChatUsage.');
        }

        if (ownerId === null || ownerId === undefined) {
            throw new Error('Required parameter ownerId was null or undefined when calling resetChatUsage.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminContingentDto>('post',`${this.basePath}/admin/contingents/${encodeURIComponent(String(scope))}/${encodeURIComponent(String(ownerId))}/reset-chat-usage`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Bestandsgrenzen setzen
     * Speicher, myCheck-Vorlagen und Chat-Token-Limit. Fehlendes Feld &#x3D; unveraendert, -1 &#x3D; Grenze aufheben.
     * @param scope 
     * @param ownerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLimits(scope: string, ownerId: number, body?: AdminContingentLimitsRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AdminContingentDto>;
    public updateLimits(scope: string, ownerId: number, body?: AdminContingentLimitsRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminContingentDto>>;
    public updateLimits(scope: string, ownerId: number, body?: AdminContingentLimitsRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminContingentDto>>;
    public updateLimits(scope: string, ownerId: number, body?: AdminContingentLimitsRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (scope === null || scope === undefined) {
            throw new Error('Required parameter scope was null or undefined when calling updateLimits.');
        }

        if (ownerId === null || ownerId === undefined) {
            throw new Error('Required parameter ownerId was null or undefined when calling updateLimits.');
        }


        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminContingentDto>('put',`${this.basePath}/admin/contingents/${encodeURIComponent(String(scope))}/${encodeURIComponent(String(ownerId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
